export { default as GDMInputCheckbox } from './GDMInputCheckbox';

export type { GDMInputCheckboxComponent, GDMInputCheckboxProps } from './GDMInputCheckbox.type';
